var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.2109,
    y: 62.5352,
    width: 390.951,
    height: 363.595,
    rx: 41.0327,
    fill: "#F0FFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.972 395.861C21.3296 393.01 23.4974 390.3 26.4197 390.3H470.927C474.326 390.3 476.53 393.887 474.993 396.92L457.965 430.529C457.184 432.069 455.601 433.036 453.874 433.027L33.4633 430.782C31.3406 430.771 29.5066 429.296 29.04 427.225L21.972 395.861Z",
    fill: "#F0FFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7031 347.343C53.7031 347.343 53.7056 128.576 53.7031 101.479C53.7007 74.3817 63.7754 62.0002 93.1818 62.0001C122.588 61.9999 358.686 62.0001 393.53 62.0001C428.373 62 443.846 75.1585 443.846 101.479C443.846 127.799 443.846 347.343 443.846 347.343",
    stroke: "#F0FFF1",
    strokeWidth: 26.2207,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.82 387.685C145.82 387.685 56.0279 387.687 28.158 387.685C0.288236 387.682 31.2607 438 49.0585 438.001C66.8563 438.001 411.327 438.001 431.46 438.001C451.593 438.001 498.026 387.684 477.131 387.685C456.237 387.685 347.084 387.685 347.084 387.685",
    stroke: "#F0FFF1",
    strokeWidth: 27.8595,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.969 387.57L311.485 387.57",
    stroke: "#F0FFF1",
    strokeWidth: 27.8595
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.812 323.192V252.525",
    stroke: "#231942",
    strokeWidth: 54.7103,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.531 323.192V179.578",
    stroke: "#231942",
    strokeWidth: 54.7103,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M354.141 323.192L354.141 221.75",
    stroke: "#231942",
    strokeWidth: 54.7103,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.79139261bd5e0b3436c00d2fe92f5c6b.svg";
export { ForwardRef as ReactComponent };